export default {"src":"/_next/static/media/women-banner.7ea315bf.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};